/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { useAuth } from '../lib/authContext';
import { isEmptyObject } from '../lib/helpers';

const PrivateRoute = props => {
  const { component: Component, ...rest } = props;
  const { user } = useAuth();

  const isAuthorised = () => {
    return user && !isEmptyObject(user.profile);
  };

  const redirectOrRender = (ownProps, isAuth) => {
    const { match } = ownProps;
    const landingPaths = [
      '/continue/:applicationId',
      '/provisional-offer/:applicationId',
      '/reload',
    ];
    const isLandingPath = landingPaths.indexOf(match.path) > -1;

    if ((!isLandingPath && isAuth) || isLandingPath) {
      return <Component {...ownProps} />;
    }

    if (!isLandingPath && !isAuth && match.path !== '/') {
      return <Redirect to={{ pathname: '/reload', state: { from: match } }} />;
    }

    return <Redirect to={{ pathname: '/', state: { from: match } }} />;
  };

  return <Route {...rest} render={ownProps => redirectOrRender(ownProps, isAuthorised())} />;
};

PrivateRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default PrivateRoute;
